import { FeatureFlags as CatalogFeatureFlags } from '@tableau/data-catalog-client-components';
import { defaultMemoize } from 'reselect';

import { FeatureFlags as VizportalClientFeatureFlags } from '../ts/FeatureFlags';

// This object is lazy-loaded because the feature flags aren't fully set up until after the app login
export const catalogFeatureFlagsAdapter = defaultMemoize((): CatalogFeatureFlags => {
  return {
    metricsDataCatalogEnabled: VizportalClientFeatureFlags.metricsDataCatalogEnabled,
    writableFieldDescriptionsEnabled: VizportalClientFeatureFlags.writableFieldDescriptionsEnabled,
    markupEditingEnabled: VizportalClientFeatureFlags.markupEditingEnabled,
    personalSpaceEnabled: VizportalClientFeatureFlags.personalSpaceEnabled,
    externalAssetsWithCRASSEnabled: VizportalClientFeatureFlags.externalAssetsWithCRASSEnabled,
    dqcertificationVisualDesignEnabled: true,
    fieldDescriptionInheritanceLineageEnabled: VizportalClientFeatureFlags.fieldDescriptionInheritanceLineageEnabled,
    incompleteCustomSqlEnabled: VizportalClientFeatureFlags.incompleteCustomSqlEnabled,
  };
});
